import { type IFetchOrders } from '@/types/IFetchOrders';
import { createOrdersUrl } from '../utils/createOrdersUrl';
import {
  CustomError,
  getErrorData,
  type IErrorData
} from '../utils/getErrorData';
import axios, { type AxiosRequestConfig } from 'axios';
import { getHeaders } from '../utils/getHeaders';
import { api } from '../utils/api';

export interface OrdersByParamsOptionsType {
  filters: Record<string, string | number | undefined>;
  signal: AbortSignal;
}

export type AbortErrorType = 'Abort';

export const getOrdersByParams = async (
  props: OrdersByParamsOptionsType
): Promise<IFetchOrders | IErrorData | AbortErrorType> => {
  const { filters, signal } = props;
  try {
    if (filters === null || filters === undefined) {
      throw new Error('Отсутствуют параметры поиска для запроса');
    }

    const headers = getHeaders();
    const url = createOrdersUrl(filters);
    const requestOptions: AxiosRequestConfig = {
      method: 'GET',
      headers,
      signal
    };

    const response = await api.get<IFetchOrders>(url, requestOptions);

    if (response.status === 500) {
      throw new CustomError(
        'При получении заказов произошла необработанная ошибка'
      );
    }

    return response.data;
  } catch (error) {
    if (axios.isCancel(error)) {
      throw new Error('Запрос отменен');
    }
    const errorData = getErrorData(error);
    // eslint-disable-next-line no-console
    console.error('Ошибка при получении заказов:', error);
    return errorData;
  }
};

export const downloadRouteSheet = async (
  props: OrdersByParamsOptionsType
): Promise<string | IErrorData> => {
  const { filters, signal } = props;
  const url = createOrdersUrl(filters).replace('/orders', '/orders/download');
  const headers = getHeaders();
  const requestOptions: AxiosRequestConfig = {
    method: 'GET',
    headers,
    signal
  };

  try {
    const response = await api.get<{ response: string }>(url, requestOptions);

    if (response.status === 500) {
      throw new CustomError(
        'При скачивании маршрутного листа произошла необработанная ошибка'
      );
    }

    const fileUrl = response.data.response;
    return fileUrl;
  } catch (error) {
    const errorData = getErrorData(error);
    // eslint-disable-next-line no-console
    console.error('Ошибка при скачивании маршрутного листа:', error);
    return errorData;
  }
};
